<template>
  <div>
    <v-form v-model="valid">
      <v-container>
        <v-row>
          <v-col cols="12" md="6">
            <MaskedTextField
              :pattern="/[А-Яа-яёЁ-]/"
              :rules="[rules.required('Пожалуйста представьтесь')]"
              v-model="second"
              label="Фамилия"
            />
          </v-col>
          <v-col cols="12" md="6">
            <MaskedTextField
              :pattern="/[А-Яа-яёЁ]/"
              :rules="[rules.required('Пожалуйста представьтесь')]"
              v-model="first"
              label="Имя"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <MaskedTextField
              :pattern="/[\sА-Яа-яёЁ]/"
              :rules="[rules.required('Пожалуйста представьтесь')]"
              v-model="middle"
              label="Отчество"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :rules="[rules.required('Введите e-mail'), rules.email]"
              v-model="localEmail"
              outlined
              label="E-mail"
              dense
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <div class="d-flex">
      <v-btn class="btn" @click="updateContacts" :disabled="!valid" x-large color="primary" style="margin-left: auto"
        >Продолжить</v-btn
      >
    </div>
  </div>
</template>

<script>
import MaskedTextField from "@/components/common/MaskedTextField";
import { email as ruleEmail } from "@/utils/rules";
import { mapActions, mapState } from "vuex";

export default {
  components: { MaskedTextField },
  data() {
    return {
      valid: false,
      first: "",
      second: "",
      middle: "",
      localEmail: "",
      rules: {
        required: (msg) => (v) => !!v || msg,
        email: ruleEmail,
      },
    };
  },
  watch: {
    firstname(v) {
      this.first = v;
    },
    surname(v) {
      this.second = v;
    },
    middlename(v) {
      this.middle = v;
    },
    email(v) {
      this.localEmail = v;
    },
  },
  methods: {
    ...mapActions("profile", ["updateProfile"]),
    updateContacts() {
      const data = {
        firstname: this.first,
        surname: this.second,
        middlename: this.middle,
      };

      // проверка email на случай, если он уже внесен (старый клиент и пр.). Повторная отправка email на бек вызовет ошибку
      if (this.email !== this.localEmail) {
        data.email = this.localEmail;
      }
      this.updateProfile(data);
    },
  },
  computed: {
    ...mapState("profile", ["firstname", "surname", "middlename", "email"]),
  },
  mounted() {
    this.first = this.firstname;
    this.second = this.surname;
    this.middle = this.middlename;
    this.localEmail = this.email;
  },
};
</script>
<style scoped>
@media (max-width: 600px) {
  .btn {
    margin: 0 auto;
    margin-left: inherit;
  }
}
</style>
